interface AcceptIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const AcceptIcon = ({ width = 16, height = 16, className }: AcceptIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <g clipPath="url(#clip0_accept_icon)">
      <path
        d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM7.93933 10.2793C7.68133 10.5373 7.342 10.666 7.00133 10.666C6.66067 10.666 6.318 10.536 6.05733 10.276L4.68179 8.94298C4.41719 8.68656 4.41059 8.26417 4.66706 7.99961C4.92348 7.73509 5.34578 7.72851 5.61032 7.9849L6.99333 9.32533L10.3906 5.99124C10.6533 5.73341 11.0752 5.73696 11.3335 5.99917C11.5922 6.26177 11.5891 6.6844 11.3264 6.94309L7.93933 10.2793Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_accept_icon">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default AcceptIcon;
